export const VALIDATE_SUBDOMAIN = "VALIDATE_SUBDOMAIN";